import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { REDUCERS } from "../../constants";

import { fetchUploadsInBatch } from "./thunks";

import { sortUploadsByStatus } from "./helpers";

export const uploadsAdapter = createEntityAdapter();
const uploadsSelectors = uploadsAdapter.getSelectors();

export const uploadsSlice = createSlice({
    name: REDUCERS.UPLOADS,
    initialState: uploadsAdapter.getInitialState({
        status: "idle"
    }),
    reducers: {
        updateUpload: uploadsAdapter.updateOne,
        uploadStatusesChanged: (state, action) => {
            uploadsAdapter.upsertMany(state, action.payload);

            const uploads = uploadsSelectors.selectAll(state);
            sortUploadsByStatus(state, uploads);
        },
        setGemStatusToTrue: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                isGem: true
            });
        },
        setGemStatusToFalse: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                isGem: false
            });
        },
        setMatureToTrue: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                mature: true
            });
        },
        setMatureToFalse: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                mature: false
            });
        },
        setExplicitStatusToFalse: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                autoNudity: false,
                autoViolence: false
            });
        },
        needsReleaseStatusSetToFalse: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                hasRecognizablePeopleOrProperty: false
            });
        },
        editorialUseOnlySetToFalse: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                editorialUseOnly: false
            });
        },
        hasWarningTextSetToFalse: (state, action) => {
            uploadsAdapter.upsertOne(state, {
                id: action.payload,
                autoWarningText: false
            });
        }
    },
    extraReducers: builder => {
        // initial fetch for all uploads in batch from server
        builder.addCase(fetchUploadsInBatch.pending, (state, action) => {
            state.status = "loading";
        });

        builder.addCase(fetchUploadsInBatch.fulfilled, (state, action) => {
            // addMany will only add if they do not exist.
            // If they already exist, they are left as is, regardless of if they changed.
            // setMany replaces existing no matter what
            uploadsAdapter.setMany(state, action.payload);

            const uploads = uploadsSelectors.selectAll(state);
            sortUploadsByStatus(state, uploads);

            state.status = "idle";
        });
    }
});

export const {
    updateUpload,
    uploadSavedForLater,
    resumedModForUpload,
    uploadDenied,
    uploadVisuallyPublished,
    uploadFullyPublished,
    setGemStatusToTrue,
    setGemStatusToFalse,
    setMatureToTrue,
    setMatureToFalse,
    setExplicitStatusToFalse,
    needsReleaseStatusSetToFalse,
    editorialUseOnlySetToFalse,
    hasWarningTextSetToFalse,
    uploadStatusesChanged
} = uploadsSlice.actions;
export { fetchUploadsInBatch } from "./thunks";
export default uploadsSlice.reducer;
